/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Note/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import InlineNoteEditor from 'DesignSystem/InlineNoteEditor/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Note({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Expanded/Content/Notes/Add/Content/Note/Note",
  onChange
  
}) {
let editedNoteNoteChangeData = fromData.useDataChange({ viewPath,
context: 'edited_note',
path: 'note',
})
let eventAppointmentIdValueData = fromData.useDataFormat({ viewPath,
context: 'event',
path: 'appointment._id',
format: fromHelpers.getContainerId,
})
let onAutocompleteAction = fromHelpers.useOnAutocompleteAction({
  children,
  viewPath,
  onChange
  
})
let onAutocompleteFetch = fromHelpers.useOnAutocompleteFetch({
  children,
  viewPath,
  onChange
  
})
  return (<React.Fragment
>
<InlineNoteEditor
  viewPath={`${viewPath}/InlineNoteEditor`}
 data="edited_note.note"
 onChange={editedNoteNoteChangeData}
 autocomplete={true}
 onAutocompleteAction={onAutocompleteAction}
 onAutocompleteFetch={onAutocompleteFetch}
 data="event.appointment._id"
 format="helpers.js getContainerId"
 containerId={eventAppointmentIdValueData}
/>
{children}
</React.Fragment>)
}